import { CSSProperties } from 'react';
import { grey } from 'globals/colors';

export const skipButtonStyle = (): CSSProperties => ({
  paddingLeft: 8,
  paddingRight: 8,
  fontWeight: 400,
});

export const mainButtonStyle = (): CSSProperties => ({
  background: grey.V5,
});
